<template>
  <v-layout class="px-2">
    <v-flex xs1 md1 class="pt-3">
      <slot></slot>
    </v-flex>
    <v-flex xs11 md2>
      <v-autocomplete
        :loading="academicYearItems.length < 1"
        :items="academicYearItems"
        label="ปี/ภาคการศึกษา"
        v-model="item.academicYear.id"
        item-value="id"
        item-text="yearSemester"
        hide-details
        :disabled="academicYearDisabled"
      ></v-autocomplete>
    </v-flex>  
    <v-flex xs12 md2>
      <v-select
        :items="courseTypeItems"
        label="หลักสูตร"
        v-model="item.courseType"
        item-value="value"
        item-text="text"
        :disabled="item.academicYear.id === null"
        hide-details
      ></v-select>
    </v-flex>
    <v-flex xs12 md7>
      <v-autocomplete
        :loading="loadingActiveCourses"
        :items="activeCourseItems"
        label="รายวิชา"
        v-model="item.id"
        item-value="id"
        item-text="subjectLabel"
        no-data-text="ไม่พบข้อมูล"
        :disabled="activeCourseDisabled"
        hide-details
      ></v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['item', 'academicYearItems'],
  data () {
    return {
      loadingAcademicYear: false,
      loadingActiveCourses: false,
      loadingSections: false,
      academicYear: null,
      activeCourse: this.item,
      courseType: null,
      courseTypeDisabled: true,
      activeCourseItems: [],
      rules: {
        required: (value) => !!value || 'ไม่สามารถเป็นค่าว่าง'
      }
    }
  },
  computed: {
    ...mapGetters({
      courseTypeItems: 'activeCourse/courseTypeItems'
    }),
    academicYearDisabled () {
      return this.academicYearItems.length === 0
    },
    activeCourseDisabled () {
      return this.activeCourseItems.length === 0
    },
    readOnly () {
      return !! this.item.id 
    }
  },
  mounted () {
    if (this.item.academicYear.id && this.item.courseType) {
      // console.log('mounted called...')
      this.fetchActiveCourses()
    }
  },
  methods: {
    fetchActiveCourses () {
      this.loadingActiveCourses = true
      let params = {
        academicYear: this.item.academicYear.id,
        courseType: this.item.courseType
      }
      // console.log('fetchActiveCourses params....', params)
      this.$store.dispatch('activeCourse/fetchItemsByAcademicYearAndCourseType', params)
        .then((response) => {
          this.loadingActiveCourses = false
          this.activeCourseItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
          this.loadingActiveCourses = false
        })
    }
  },
  watch: {
    'item.academicYear.id' (val) {
      if(val) {
        this.courseType = null
        this.activeCourse = null
      }
    },
    'item.courseType' (val) {
      // console.log('watch -> courseType', val)
      if(this.item.academicYear.id && val) {
        this.fetchActiveCourses()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/activity/gen/formActiveCourse.vue